import React from "react";
import moment from "moment";
const format1 = "YYYY-MM-DD"

export const CreateDateColumnFormatter = (cellContent, row) => {
  return(<span>{moment(row.created_at).format(format1)}</span>)
}
